// src/pages/CategoriesPage.js
import React, { useState, useCallback } from 'react';
import CategoryForm from '../components/CategoryForm';
import CategoryList from '../components/CategoryList';

const CategoriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCategoryAdded = (category) => {
    console.log('Category added:', category);
    setSelectedCategory(null);
    refreshCategories();
    handleAlert('Category created successfully!', 'success');
  };

  const handleCategoryUpdated = () => {
    setSelectedCategory(null);
    refreshCategories();
    handleAlert('Category updated successfully!', 'success');
  };

  const handleCategoryDeleted = () => {
    setSelectedCategory(null);
    refreshCategories();
    handleAlert('Category deleted successfully!', 'success');
  };

  const handleEditCategory = (category) => {
    setSelectedCategory(category);
  };

  const handleAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert({ message: '', type: '' }), 3000);
  };

  const refreshCategories = useCallback(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, []);

  return (
    <div className="container mt-4">
      {/* <h1 className='text-centre'>Manage Categories</h1> */}
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <CategoryForm
        category={selectedCategory}
        onCategoryAdded={handleCategoryAdded}
        onCategoryUpdated={handleCategoryUpdated}
        onAlert={handleAlert}
      />
      <CategoryList
        key={refreshKey}
        onCategoryDeleted={handleCategoryDeleted}
        onEditCategory={handleEditCategory}
      />
    </div>
  );
};

export default CategoriesPage;
